module.exports = __webpack_public_path__ + "static/media/reviewable_list.634131d3.png";